module.exports = __webpack_public_path__ + "static/media/about-page-image.c80a5992.svg";